import { createActions } from 'redux-actions';

import { PersonalAccidentQuoteCompare } from '@models/PersonalAccidentQuote';
import { ComparePersonalAccidentQuoteParams } from '@apis/PersonalAccidentQuoteApi';

export type State = {
  personalAccidentQuotes?: PersonalAccidentQuoteCompare[] | null;
};

export type PersonalAccidentQuotesFetchPayload = ComparePersonalAccidentQuoteParams;
export type StateUpdatePayload = Partial<State>;

export const {
  personalAccidentQuotesFetch,
  stateUpdate,
} = createActions(
  'PERSONAL_ACCIDENT_QUOTES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'PERSONAL_ACCIDENT_QUOTE_COMPARE_PAGE',
  }
);
